import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DocumentsService } from "../../../../../auth/service/documents.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../../../../../auth/service";
import { locale as italian } from "../../../../../i18n/it";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-staff-single-document-file",
  templateUrl: "./staff-single-document-file.component.html",
  styleUrls: ["./staff-single-document-file.component.scss"],
})
export class StaffSingleDocumentFileComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  public contentHeader: IContentHeader;

  public document: any = null;

  public file: any;

  public idDocument: any;

  public currentUser: ICurrentUser;

  public user_hash: any;

  public rejectedNote: string = "";

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    public route: ActivatedRoute,
    public _authenticationService: AuthenticationService,
    public _modalService: NgbModal,
    public _rotuerService: Router,
  ) {
    this.idDocument = this.route.snapshot.paramMap.get("id");
    this.route.queryParams.subscribe((params) => {
      this.user_hash = params.hash;
    });
  }

  async ngOnInit() {
    this.currentUser = await this._authenticationService.getCurrentUser();

    await this.loadDocument();
    if (this.document) {
      this.contentHeader = {
        headerTitle: this.document.document_data.title,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: italian.data.MENU.DOCUMENTS_LIST,
              isLink: true,
              link: this.currentUser.role === "Supporto asset" ? "/dashboard/documents/assets-list" : "/dashboard/documents-list",
            },
            {
              name: this.document.document_data.title,
              isLink: false,
            },
          ],
        },
      };
    }
  }

  async loadDocument() {
    this.document = await this._documentService.getUserDocument(this.idDocument, { hash: this.user_hash });
    this.document.document_data.description = this.document.document_data.description.includes("users/") ? "" : this.document.document_data.description;
    this.document.file_url = await this._utilService.includeFile(this.document.path_file);
  }

  async handlerChangeFileInput(event: any) {
    await this._utilService.convertFileToBase64(event, async (e: any) => {
      return (this.file = e.target.result);
    });
  }

  openModal(modal) {
    this._modalService.open(modal, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
    this.rejectedNote = "";
  }

  modalClose() {
    this._modalService.dismissAll();
    this.rejectedNote = "";
    this.callbackFn.emit();
  }

  async rejectDocument() {
    let data = { hash: this.user_hash, status: 2, status_note: null };
    data.status_note = this.rejectedNote;
    await this._documentService
      .updateUserDocument(this.idDocument, data, "/status")
      .then(async () => {
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_DOCUMENT" });
        if (this.currentUser.role === "Supporto asset") {
          await this._rotuerService.navigateByUrl("/dashboard/documents/assets-list");
        } else {
          await this._rotuerService.navigateByUrl("/dashboard/document-staff-view/" + this.idDocument);
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_DOCUMENT" }));
    this.modalClose();
    await this.loadDocument();
  }

  async acceptDocument() {
    let data = { hash: this.user_hash, status: 1, status_note: null };
    await this._documentService
      .updateUserDocument(this.idDocument, data, "/status")
      .then(async () => {
        await this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVED_DOCUMENT" });
        if (this.currentUser.role === "Supporto asset") {
          await this._rotuerService.navigateByUrl("/dashboard/documents/assets-list");
        } else {
          await this._rotuerService.navigateByUrl("/dashboard/document-staff-view/" + this.idDocument);
        }
        await this.loadDocument();
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_DOCUMENT" }));
  }

  async download(fileName: string) {
    return this._utilService.document_file(fileName);
  }
  async deleteDocument() {
    if (!this._authenticationService.hasCapability("delete_document")) {
      await this._rotuerService.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += this.document.document_data.title;
    if (this.document) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._documentService
            .delete(this.document.document_id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this._rotuerService.navigateByUrl("/dashboard/documents-list");
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DOCUMENT_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
  }
}
